import { useQueryClient, useMutation } from 'react-query';
import { useAxiosInstance } from '../../common';

const useClearConfigs = (orgId: string) => {
  const axios = useAxiosInstance();
  const queryClient = useQueryClient();
  return useMutation(
    async (params: {clientProjectId: string, configId: string}) => {
      const response = await axios.post<string>(`data_wrangling/${params.clientProjectId}/configs/${params.configId}/clear`);
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['clientProjects', orgId], { refetchInactive: true });
        queryClient.invalidateQueries(['sapGroups'], { refetchInactive: true });
      },
    }
  );
};

export default useClearConfigs;
